import React from 'react';
import { useSelector } from 'react-redux';
import { hobOrgSelector } from '../redux/selector';
import HobListingMmt from './mmt-components/HobListingMmt/HobListingMmt';
import HobListing from './gi-components/HobListing/HobListing';

const HobListingPage = (props) => {

  const orgId = useSelector(hobOrgSelector)

  return (
    <>
      {orgId === "MMT" ? <HobListingMmt {...props} /> : <HobListing {...props} /> }
    </>
  )
};

export default HobListingPage;